const transformToFullUrl = (url: string, containerUrl: string): string => {
  if (url.startsWith('http') || url.startsWith('https')) {
    return url
  }

  let cleanPath = url
  if (cleanPath.startsWith('/')) {
    cleanPath = cleanPath.substring(1)
  }

  try {
    cleanPath = decodeURIComponent(cleanPath)
  } catch (e) {
    console.warn('Failed to decode URL, using original path', e)
  }

  const encodedPath = cleanPath
    .split('/')
    .map((part) => encodeURIComponent(part))
    .join('/')

  return `${containerUrl}${encodedPath}`
}

export default transformToFullUrl
